// axios
import axios from "axios";


const instance = axios.create({
  baseURL: "/api/",
  // You can add your headers here
  timeout: 120000,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
  },
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      import("./router").then((router) => {
        router.default.push("/login").catch(() => {});
      });
    }

    if (error.response && error.response.status === 404) {
      import("./router").then((router) => {
        router.default.push("/pages/error-404").catch(() => {});
      });
    }

    return Promise.reject(error);
  },
);

export default instance;
